import { Outlet, useParams } from "react-router-dom";
import {
  useGetDashboardProfileQuery,
  useGetDashboardProfilebyIdQuery,
} from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import ProjectNavbar from "../Project/ProjectNavbar";
import { useLocation } from "react-router-dom";
const ProjectLayout = () => {
  //    const projectId = localStorage.getItem("projectId");
  //   console.log("projectId",projectId)
  //  const { data: userProfile, isLoading,refetch } = useGetDashboardProfilebyIdQuery(
  //    projectId?projectId: "",

  //      {
  //        refetchOnMountOrArgChange: true,
  //      }
  //    );
  return (
    <div className="min-h-screen bg-white">
      <ProjectNavbar />
      <div
        style={{
          background: "#f5f7fa",
          minHeight: "100vh",
        }}
      >
        <main
          style={{
            paddingLeft: "0",
            paddingRight: "0",
          }}
          className="main-content"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProjectLayout;
